var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _handleResize, _CustomDialog_instances, inflateDeferred_fn, _morphObserver, startMorphObserver_fn, stopMorphObserver_fn, waitForStylesheets_fn, handleClick_fn, handleKeyDown_fn, handleParamHintToOpen_fn;
import { C as Component, n as hasInteracted, p as onFirstInteraction, d as debounce, t as lazyReveal, q as activateInteractionAssets, u as onAnimationEnd, E as isClickedOutside } from "./utilities-Da0sjanJ.js";
const _DialogOpenEvent = class _DialogOpenEvent extends CustomEvent {
  constructor() {
    super(_DialogOpenEvent.eventName, { bubbles: true });
  }
};
__publicField(_DialogOpenEvent, "eventName", "dialog:open");
let DialogOpenEvent = _DialogOpenEvent;
const _DialogCloseEvent = class _DialogCloseEvent extends CustomEvent {
  constructor() {
    super(_DialogCloseEvent.eventName, { bubbles: true });
  }
};
__publicField(_DialogCloseEvent, "eventName", "dialog:close");
let DialogCloseEvent = _DialogCloseEvent;
class CustomDialog extends Component {
  constructor() {
    super();
    __privateAdd(this, _CustomDialog_instances);
    __publicField(this, "requiredRefs", ["dialog"]);
    __privateAdd(this, _handleResize, debounce(() => {
      const { minWidth, maxWidth } = this;
      if (!minWidth && !maxWidth) return;
      const windowWidth = window.innerWidth;
      if (windowWidth < minWidth || windowWidth > maxWidth) this.closeDialog();
    }, 50));
    /**
     * Watches for section morphs that re-introduce <template> elements while dialog is open.
     * Starts observing when dialog opens, stops when it closes.
     */
    __privateAdd(this, _morphObserver, null);
    __publicField(this, "closeDialog", async () => {
      const { dialog, closeButton } = this.refs;
      if (!dialog.open) return;
      this.removeEventListener("click", __privateMethod(this, _CustomDialog_instances, handleClick_fn));
      this.removeEventListener("keydown", __privateMethod(this, _CustomDialog_instances, handleKeyDown_fn));
      dialog.classList.add("dialog-closing");
      await onAnimationEnd(dialog, void 0, {
        subtree: false
      });
      dialog.close();
      closeButton.setAttribute("aria-expanded", "false");
      this.querySelectorAll("custom-dialog").forEach((childDialog) => {
        if (childDialog === this) return;
        const child = childDialog.querySelector("dialog");
        if ((child == null ? void 0 : child.open) && typeof childDialog.closeDialog === "function") {
          childDialog.closeDialog();
        }
      });
      dialog.classList.remove("dialog-closing");
      this.dispatchEvent(new DialogCloseEvent());
      __privateMethod(this, _CustomDialog_instances, stopMorphObserver_fn).call(this);
    });
    __publicField(this, "toggleDialog", () => {
      if (this.refs.dialog.open) {
        this.closeDialog();
      } else {
        this.showDialog();
      }
    });
    this.openByDefault = this.getAttribute("data-open-by-default") === "true";
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.minWidth || this.maxWidth) window.addEventListener("resize", __privateGet(this, _handleResize));
    __privateMethod(this, _CustomDialog_instances, handleParamHintToOpen_fn).call(this);
    this.openByDefault && this.showDialog();
    if (this.querySelector("template.deferred-content")) {
      const scheduleIdle = () => {
        if ("requestIdleCallback" in window) requestIdleCallback(() => __privateMethod(this, _CustomDialog_instances, inflateDeferred_fn).call(this), { timeout: 3e3 });
        else setTimeout(() => __privateMethod(this, _CustomDialog_instances, inflateDeferred_fn).call(this), 500);
      };
      if (hasInteracted()) {
        scheduleIdle();
      } else {
        onFirstInteraction(scheduleIdle, 0);
      }
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.minWidth || this.maxWidth) window.removeEventListener("resize", __privateGet(this, _handleResize));
    __privateMethod(this, _CustomDialog_instances, stopMorphObserver_fn).call(this);
  }
  async showDialog() {
    __privateMethod(this, _CustomDialog_instances, inflateDeferred_fn).call(this);
    await __privateMethod(this, _CustomDialog_instances, waitForStylesheets_fn).call(this);
    const { dialog, closeButton } = this.refs;
    if (dialog.open) return;
    const currentDialogOpen = document.querySelector("dialog[open]");
    if (currentDialogOpen && !(currentDialogOpen == null ? void 0 : currentDialogOpen.contains(this))) {
      const CustomDialog2 = currentDialogOpen.closest("custom-dialog, quick-view-dialog, cart-drawer");
      const isSearchDrawer = (CustomDialog2 == null ? void 0 : CustomDialog2.id) === "SearchDrawer";
      const isCartDrawer = (CustomDialog2 == null ? void 0 : CustomDialog2.id) === "CartDrawer";
      if (CustomDialog2 && !isSearchDrawer && !isCartDrawer) {
        await CustomDialog2.closeDialog();
      }
    }
    dialog.showModal();
    closeButton.focus({ preventScroll: true });
    closeButton.setAttribute("aria-expanded", "true");
    this.dispatchEvent(new DialogOpenEvent());
    setTimeout(() => {
      this.addEventListener("click", __privateMethod(this, _CustomDialog_instances, handleClick_fn));
      this.addEventListener("keydown", __privateMethod(this, _CustomDialog_instances, handleKeyDown_fn));
    });
    __privateMethod(this, _CustomDialog_instances, startMorphObserver_fn).call(this);
  }
  get minWidth() {
    return Number(this.getAttribute("dialog-active-min-width"));
  }
  get maxWidth() {
    return Number(this.getAttribute("dialog-active-max-width"));
  }
}
_handleResize = new WeakMap();
_CustomDialog_instances = new WeakSet();
/**
 * Inflates any <template class="deferred-content"> elements inside this dialog.
 * Safe to call multiple times — after section morphs, new templates may arrive.
 */
inflateDeferred_fn = function() {
  for (const tpl of this.querySelectorAll("template.deferred-content")) {
    const frag = document.createDocumentFragment();
    frag.append(...tpl.content.childNodes);
    const scripts = frag.querySelectorAll("script");
    for (const old of scripts) {
      const fresh = document.createElement("script");
      for (const attr of old.attributes) {
        fresh.setAttribute(attr.name, attr.value);
      }
      fresh.textContent = old.textContent;
      old.replaceWith(fresh);
    }
    const newNodes = Array.from(frag.children);
    tpl.replaceWith(frag);
    newNodes.forEach((child) => lazyReveal(child));
  }
  activateInteractionAssets(this);
};
_morphObserver = new WeakMap();
startMorphObserver_fn = function() {
  if (__privateGet(this, _morphObserver)) return;
  __privateSet(this, _morphObserver, new MutationObserver(() => {
    if (this.querySelector("template.deferred-content")) {
      __privateMethod(this, _CustomDialog_instances, inflateDeferred_fn).call(this);
    }
  }));
  __privateGet(this, _morphObserver).observe(this, { childList: true, subtree: true });
};
stopMorphObserver_fn = function() {
  var _a;
  (_a = __privateGet(this, _morphObserver)) == null ? void 0 : _a.disconnect();
  __privateSet(this, _morphObserver, null);
};
waitForStylesheets_fn = async function() {
  const links = Array.from(this.querySelectorAll('link[rel="stylesheet"], link[rel="preload"][as="style"]'));
  const promises = links.map((link) => {
    if (link.sheet || link.getAttribute("data-loaded") === "true") return Promise.resolve();
    return new Promise((resolve) => {
      const markLoaded = () => {
        link.setAttribute("data-loaded", "true");
        resolve();
      };
      link.addEventListener("load", markLoaded, { once: true });
      link.addEventListener("error", markLoaded, { once: true });
      setTimeout(markLoaded, 500);
    });
  });
  if (promises.length > 0) {
    this.classList.add("dialog-loading-assets");
    await Promise.all(promises);
    this.classList.remove("dialog-loading-assets");
  }
};
handleClick_fn = function(event) {
  const { dialog } = this.refs;
  const dialogInner = dialog.firstElementChild;
  const subDrawer = dialog.querySelector(".sub-drawer.open");
  const isSubDrawerActive = dialog.classList.contains("sub-drawer-active");
  const cartDrawerFeatureElement = dialog.querySelector("sub-drawer.open");
  if (isSubDrawerActive && !(event.target.closest("button") instanceof HTMLButtonElement)) {
    if (cartDrawerFeatureElement && isClickedOutside(event, subDrawer)) {
      cartDrawerFeatureElement.closeSubDrawer();
    }
  }
  if (isClickedOutside(event, dialogInner)) {
    this.closeDialog();
    if (cartDrawerFeatureElement) {
      cartDrawerFeatureElement.closeSubDrawer();
    }
  }
};
handleKeyDown_fn = function(event) {
  if (event.key !== "Escape") return;
  event.preventDefault();
  const { dialog } = this.refs;
  const isSubDrawerActive = dialog.classList.contains("sub-drawer-active");
  if (isSubDrawerActive) {
    const cartDrawerFeatureElement = dialog.querySelector("sub-drawer.open");
    if (cartDrawerFeatureElement) {
      cartDrawerFeatureElement.closeSubDrawer();
    }
    return;
  }
  this.closeDialog();
};
handleParamHintToOpen_fn = function() {
  const { dialog } = this.refs;
  const paramHintToOpen = dialog.getAttribute("param-hint-to-open");
  if (!paramHintToOpen) return;
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has(paramHintToOpen)) {
    this.showDialog();
  }
};
if (!customElements.get("custom-dialog")) {
  customElements.define("custom-dialog", CustomDialog);
}
document.addEventListener(
  "toggle",
  (event) => {
    var _a, _b;
    if (event.target instanceof HTMLDialogElement || event.target instanceof HTMLDetailsElement) {
      if (event.target.hasAttribute("no-scroll")) {
        const { open } = event.target;
        if (open) {
          document.documentElement.setAttribute("no-scroll", "");
          (_a = Theme == null ? void 0 : Theme.lenis) == null ? void 0 : _a.stop();
          event.target.setAttribute("data-lenis-prevent", "");
        } else {
          document.documentElement.removeAttribute("no-scroll");
          (_b = Theme == null ? void 0 : Theme.lenis) == null ? void 0 : _b.start();
          event.target.removeAttribute("data-lenis-prevent");
        }
      }
    }
  },
  { capture: true }
);
export {
  CustomDialog as C,
  DialogOpenEvent as D,
  DialogCloseEvent as a
};
